import { clsx } from "@/utils";

export interface ContainerProps {
  children: React.ReactNode;
  className?: string;
}
export const Container = ({ children, className }: ContainerProps) => {
  return <div className={clsx("mx-auto w-full max-w-screen-2xl", className)}>{children}</div>;
};
